/**
  Intro:

  SearchLink provides an interface to react-router, allowing for custom logic
  whenever the SearchLink is activated (clicked)

  Usage:  ----------------------------------------------------------------------

    import SearchLink from 'scripts/components/search/SearchLink'

    class MyClass extends Component {
      ...

      render() {
        return (
          <SearchLink
            path={ ... }
            iconClass= { ... }
            linkClass={ ... } />
        )
      }
    }

  ------------------------------------------------------------------------------=
**/

import React from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import Constants from 'scripts/base/Constants'
import { dispatcher } from 'scripts/components/search/SearchDispatcher'

const SearchLinkProto = (props) => {
  const searchCallback = (e) => {
    // If the search link is clicked, but is already on that path, scroll to top
    if (props.location.pathname === props.path) {
      dispatcher.emit(Constants.Search.SEARCH_INPUT)
    } else {
      props.history.push(props.path)
    }

    // Block href on anchor tag on firing
    e.preventDefault()
  }

  return (
    <a href={ props.path } onClick={ searchCallback } className={ props.linkClass }>
      <i className={ props.iconClass }></i>
    </a>
  )
}
const SearchLink = withRouter(SearchLinkProto)

export default SearchLink

SearchLink.propTypes = {
  path: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  linkClass: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./assets/js/components/search/SearchLink.jsx